import React, { useState, useEffect, useCallback } from 'react';
import './ListCategories.css';
import ConfirmationModal from '../../Notification/ConfirmationModal'; // Az új modal importálása
import Notification from '../../Notification/Notification'; // Az notification importálása
import CreateCategories from '../CreateCategories/CreateCategories'; // Hozzáadjuk
import CategoryFilter from '../CategoryFilter/CategoryFilter';
import { Collapse } from 'antd';

const { Panel } = Collapse;

const apiUrl = process.env.REACT_APP_API_URL;

function ListCategories() {
  const [categories, setCategories] = useState([]);
  const [filteredCategories, setFilteredCategories] = useState([]);
  const [parentCategories, setParentCategories] = useState([]);
  const [token] = useState(localStorage.getItem('token') || '');
  const [editCategory, setEditCategory] = useState(null); // Szerkesztett kategória állapota
  const [isEditing, setIsEditing] = useState(false); // Szerkesztési mód állapota
  const [showModal, setShowModal] = useState(false);
  const [selectedCategoryId, setSelectedCategoryId] = useState(null);
  const [notification, setNotification] = useState({ message: '', type: '' });


  const fetchCategories = useCallback(() => {
    fetch(`${apiUrl}/categories`, {
      headers: { 'Authorization': `Bearer ${token}` }
    })
      .then((response) => response.json())
      .then((data) => {
        setCategories(data);
        setParentCategories(data.filter((category) => category.parent_id === null));
        setFilteredCategories(data);
      })
      .catch((error) => console.error('Error fetching categories:', error));
  }, [token]);

  useEffect(() => {
    fetchCategories();
  }, [fetchCategories]);

  // Kategória szerkesztésének megkezdése
  const handleEdit = (categoryId) => {
    const categoryToEdit = categories.find(category => category.id === categoryId);
    setEditCategory(categoryToEdit);
    setIsEditing(true);
  };

  // Mentés utáni visszatérés
  const handleSaveSuccess = () => {
    setIsEditing(false);
    fetchCategories(); // Frissítjük a kategóriákat
  };

  const handleCancelEdit = () => {
    setIsEditing(false);
  };

  const handleDeleteCategory = async () => {
    const response = await fetch(`${apiUrl}/categories/${selectedCategoryId}`, {
      method: 'DELETE',
      headers: {
        'Authorization': `Bearer ${token}`,
      },
    });

    if (response.ok) {
      setNotification({ message: 'A kategória sikeresen törölve.', type: 'success' });
      fetchCategories(); // Frissítjük a listát a törlés után
      setShowModal(false); // Modal bezárása
    } else {
      setNotification({ message: 'Hiba történt a kategória törlése során.', type: 'error' });
    }
  };

  const openModal = (categoryId) => {
    setSelectedCategoryId(categoryId);
    setShowModal(true); // Modal megjelenítése
  };

  const closeModal = () => {
    setShowModal(false); // Modal bezárása
  };

  return (
    <div className="list-categories">
      {isEditing ? (
        <CreateCategories
          selectedCategory={editCategory}
          onSaveSuccess={handleSaveSuccess}
          onCancel={handleCancelEdit}
        />
      ) : (
        <>
          <h2>Kategóriák Listája</h2>
          <Collapse className="mb-3">
            <Panel header="Kategória szűrő" key="filter">
              <CategoryFilter 
                onFilter={(filters) => {
                  const newData = categories.filter(item => {
                    const matchesName = item.name.includes(filters.name);
                    const matchesDescription = item.description.includes(filters.description);
                    const matchesId = filters.selectedParentId
                      ? item.parent_id === parseInt(filters.selectedParentId)
                      : true;
                    return matchesName && matchesDescription && matchesId;
                  });
                  setFilteredCategories(newData);
                }}
                parentCategories={parentCategories}
              />
            </Panel>
          </Collapse>

          <table className="categories-table">
            <thead>
              <tr>
                <th>Azonosító</th>
                <th>Kategória Neve</th>
                <th>Leírás</th>
                <th>Szülő Kategória</th>
                <th>Műveletek</th>
              </tr>
            </thead>
            <tbody>
              {filteredCategories.map(category => (
                <tr key={category.id}>
                  <td>{category.id}</td>
                  <td>{category.name}</td>
                  <td>{category.description}</td>
                  <td>{category.parent_id ? categories.find(cat => cat.id === category.parent_id)?.name : ''}</td>
                  <td>
                    <button onClick={() => handleEdit(category.id)}>Szerkesztés</button>
                    <button 
                  onClick={() => openModal(category.id)} 
                  style={{ marginLeft: '10px', backgroundColor: '#f44336', color: 'white' }}
                >
                  Törlés
                </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </>
      )}
      {/* Modal megjelenítése */}
      <ConfirmationModal 
        show={showModal}
        message="Biztosan törölni szeretnéd ezt a kategóriát?"
        onConfirm={handleDeleteCategory}
        onCancel={closeModal}
      />

      {/* Notification komponens */}
      <Notification 
        message={notification.message} 
        type={notification.type} 
        onClose={() => setNotification({ message: '', type: '' })}
      />
    </div>
  );
}

export default ListCategories;
